import React from "react";
import { CheckCircle2, AlertCircle, Lightbulb, Shield } from "lucide-react";

export const ReportSwot = ({ strategy }) => {
  const swot = strategy.swot_analysis || {};
  return (
    <div className="space-y-6">
      <div className="grid md:grid-cols-2 gap-4">
        <div className="bg-emerald-900/20 border border-emerald-500/30 rounded-2xl p-6">
          <h3 className="font-semibold text-emerald-400 mb-4">Strengths</h3>
          <ul className="space-y-2">
            {(swot.strengths || []).map((item) => (
              <li key={`str-${item.slice(0, 30)}`} className="flex items-start gap-2 text-slate-300">
                <CheckCircle2 className="w-4 h-4 mt-1 text-emerald-400 flex-shrink-0" /> {item}
              </li>
            ))}
          </ul>
        </div>
        <div className="bg-yellow-900/20 border border-yellow-500/30 rounded-2xl p-6">
          <h3 className="font-semibold text-yellow-400 mb-4">Weaknesses</h3>
          <ul className="space-y-2">
            {(swot.weaknesses || []).map((item) => (
              <li key={`weak-${item.slice(0, 30)}`} className="flex items-start gap-2 text-slate-300">
                <AlertCircle className="w-4 h-4 mt-1 text-yellow-400 flex-shrink-0" /> {item}
              </li>
            ))}
          </ul>
        </div>
        <div className="bg-blue-900/20 border border-blue-500/30 rounded-2xl p-6">
          <h3 className="font-semibold text-blue-400 mb-4">Opportunities</h3>
          <ul className="space-y-2">
            {(swot.opportunities || []).map((item) => (
              <li key={`opp-${item.slice(0, 30)}`} className="flex items-start gap-2 text-slate-300">
                <Lightbulb className="w-4 h-4 mt-1 text-blue-400 flex-shrink-0" /> {item}
              </li>
            ))}
          </ul>
        </div>
        <div className="bg-red-900/20 border border-red-500/30 rounded-2xl p-6">
          <h3 className="font-semibold text-red-400 mb-4">Threats</h3>
          <ul className="space-y-2">
            {(swot.threats || []).map((item) => (
              <li key={`thr-${item.slice(0, 30)}`} className="flex items-start gap-2 text-slate-300">
                <Shield className="w-4 h-4 mt-1 text-red-400 flex-shrink-0" /> {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
      {swot.key_insights && (
        <div className="bg-gradient-to-br from-emerald-900/30 to-slate-900 border border-emerald-500/30 rounded-2xl p-6">
          <h3 className="font-semibold text-emerald-400 mb-2">Key Strategic Insights</h3>
          <p className="text-slate-300">{swot.key_insights}</p>
        </div>
      )}
    </div>
  );
};
